import { readable } from "svelte/store";
import { browser } from "$app/environment";

// This store provides device type and viewport information
export const deviceDetails = readable(
  {
    deviceType: "",
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    isAndroid: false,
    isIOS: false,
  },
  (set) => {
    // Check if we are in the browser environment to avoid SSR issues
    if (!browser) return;

    const updateDeviceType = () => {
      // Check if the viewport is mobile, tablet, or desktop
      const isMobileViewport = window.innerWidth < 768;
      const isTabletViewport = window.innerWidth >= 768 && window.innerWidth < 1280;
      const isDesktopViewport = window.innerWidth >= 1280;

      // Determine the device type based on the viewport
      let deviceType = "";
      if (isMobileViewport) deviceType = "mobile";
      else if (isTabletViewport) deviceType = "tablet";
      else if (isDesktopViewport) deviceType = "desktop";

      // Check if the device is Android or iOS
      const isAndroidDevice = navigator.userAgent.match(/android/i);
      const isIOSDevice = navigator.userAgent.match(/(iPad|iPhone|iPod)/i);

      set({
        deviceType,
        isMobile: isMobileViewport,
        isTablet: isTabletViewport,
        isDesktop: isDesktopViewport,
        isAndroid: !!isAndroidDevice,
        isIOS: !!isIOSDevice,
      });
    };

    // Initialize
    updateDeviceType();

    // Update on resize
    window.addEventListener("resize", updateDeviceType);

    // Cleanup
    return () => window.removeEventListener("resize", updateDeviceType);
  },
);
